import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialItemInstanceImportState: Dtos.TrialItemInstanceImport & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    active: null,
    addGroups: null,
    display: null,
    selectedItems: [],
    trialItemInstanceCategories: [],
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface ITrialItemInstanceImportReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    addGroups: IFieldState<boolean>,
    display: IFieldState<string>,
    active: IFieldState<boolean>,
    selectedItems: IFieldState<number[]>,
    trialItemInstanceCategories: IFieldState<Dtos.TrialItemInstanceCategory[]>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
